import { createAction, handleActions } from 'redux-actions';
import createRequestSaga, {
    createRequestActionTypes,
} from '../../lib/createRequestSaga';
import * as stAPI from '../../lib/api/stapi';
import * as brAPI from '../../lib/api/brandapi';
import * as pdAPI from '../../lib/api/prodapi';
import * as cmAPI from '../../lib/api/campaignapi'

import { takeLatest } from 'redux-saga/effects';

// [START] API 서버에 Request ------------------------->

const [
    MAIN_ST,
    MAIN_ST_SUCCESS,
    MAIN_ST_FAILURE,
] = createRequestActionTypes('main/MAIN_ST');

const [
    MAIN_BR,
    MAIN_BR_SUCCESS,
    MAIN_BR_FAILURE,
] = createRequestActionTypes('main/MAIN_BR');

const [
    MAIN_PD,
    MAIN_PD_SUCCESS,
    MAIN_PD_FAILURE,
] = createRequestActionTypes('main/MAIN_PD');

const [
  MAIN_CM,
  MAIN_CM_SUCCESS,
  MAIN_CM_FAILURE,
] = createRequestActionTypes('main/MAIN_CM');

const MAIN_ST_RESET = 'main/MAIN_ST_RESET'

export const reqMainStAction = createAction(MAIN_ST);
export const reqMainBrAction = createAction(MAIN_BR);
export const reqMainPdAction = createAction(MAIN_PD);
export const reqMainCmAction = createAction(MAIN_CM);

export const resetMainStAction = createAction(MAIN_ST_RESET);

/**
 * SAGA API 에서 REST API 호출
 */
const reqStMainListSaga = createRequestSaga(MAIN_ST, stAPI.getMainList);
const reqBrMainListSaga = createRequestSaga(MAIN_BR, brAPI.getMainList);
const reqPdMainListSaga = createRequestSaga(MAIN_PD, pdAPI.getMainList);
const reqCmMainBannerListSaga = createRequestSaga(MAIN_CM, cmAPI.getMainBannerList);

export function* mainContentsSaga() {
    yield takeLatest(MAIN_ST, reqStMainListSaga);
    yield takeLatest(MAIN_BR, reqBrMainListSaga);
    yield takeLatest(MAIN_PD, reqPdMainListSaga);
    yield takeLatest(MAIN_CM, reqCmMainBannerListSaga);
}
// [END] API 서버에 Request ------------------------------>

/**
 * Store에 저장될 값
 */
const initialState = {
    mainStItems: [],
    mainBrItems: [],
    mainPdItems: [],
    mainCmItems: [],
    error: null,
}

const mainReducer = handleActions(
    {
        [MAIN_ST_SUCCESS]: (state, { payload }) => {
            return ({
                ...state,
                mainStItems: payload,
                error: null,
            })
        },
        [MAIN_ST_FAILURE]: (state, { payload: error }) => ({
            ...state,
            mainStItems: [],
            error,
        }),
        [MAIN_BR_SUCCESS]: (state, { payload }) => {
            return ({
                ...state,
                mainBrItems: payload,
                error: null,
            })
        },
        [MAIN_BR_FAILURE]: (state, { payload: error }) => ({
            ...state,
            mainBrItems: [],
            error,
        }),
        [MAIN_ST_RESET]: (state, { payload }) => {
            return ({
                ...state,
                mainStItems: []
            })
        },
        [MAIN_PD_SUCCESS]: (state, { payload }) => {
            return ({
                ...state,
                mainPdItems: payload,
                error: null,
            })
        },
        [MAIN_PD_FAILURE]: (state, { payload: error }) => ({
            ...state,
            mainPdItems: [],
            error,
        }),
      [MAIN_CM_SUCCESS]: (state, { payload }) => {
        return ({
          ...state,
          mainCmItems: payload,
          error: null,
        })
      },
      [MAIN_CM_FAILURE]: (state, { payload: error }) => ({
        ...state,
        mainCmItems: [],
        error,
      }),

    }
    , initialState);

export default mainReducer;
